<template>
  <div class="footer-help-core" v-if="loading">
    <div class="breadcrumb flex aic">
      {{info.cate_name}} > {{info.title}}
    </div>
    <div class="main">
      <div v-html="info.content"></div>
    </div>
    <div class="btn-area flex aic">
      <span style="margin-right:30px">以上信息是否解决了您的问题？</span>
      <i-button type="primary"
                :disabled="isText"
                @click="btnEvent(1)">已解决</i-button>
      <i-button type="primary"
                :disabled="isText"
                @click="btnEvent(0)">未解决</i-button>
    </div>
    <p class="text"
       v-if="isText">感谢您的反馈和支持，祝您生活愉快！</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "HelpCore",
  computed: {
    ...mapGetters(['userInfo', 'helpId']),
  },
  data () {
    return {
      info: {},
      isText: false,
			loading:false
    }
  },
  watch: {
    $route () {
      this.$route.query.id ? this.getInfo(this.$route.query.id) : this.helpId && this.getInfo(this.helpId); 
      this.isText = false;
    }
  },
  methods: {
    getInfo (id) {
			if(!id){
				this.loading = false;
				return
			}
			this.loading = true;
      this.http.NEWGetHelpInfo({ id }).then(res => {
        this.info = { ...res };
      }).catch(this.$err);
    },
    btnEvent (status) {
      if(!this.userInfo.uid){
        this.ToLogin();
        return
      }
      this.http.NEWSolveHelp({ help_content_id: this.info.id, status, userid: this.userInfo.uid }).then(() => {
        this.$Message.success('提交成功');
        this.isText = true;
      }).catch(this.$err);
    }
  },
  created () {
    this.$route.query.id && this.getInfo(this.$route.query.id);
  },
}
</script>

<style lang="less" scoped>
.footer-help-core {
  .breadcrumb {
    width: 100%;
    height: 64px;
    padding: 0 24px;
    color: #333f4e;
    font-size: 16px;
    border-bottom: 1px solid #eeeeee;
  }
  .main {
    padding: 24px;
  }
  .btn-area {
    width: 100%;
    height: 64px;
    padding-left: 24px;
    color: #333f4e;
    /deep/.ivu-btn {
      width: 70px;
      height: 26px;
      margin-right: 10px;
      border-radius: 4px;
      font-size: 12px;
    }
  }
  .text {
    padding-left: 24px;
    font-size: 12px;
    color: #1177ff;
  }
}
</style>